import gql from "graphql-tag";

export default gql`
  fragment faxFilterInfo on FaxFilter {
    id
    states
  }
`;
